module.exports = __webpack_public_path__ + "static/media/WinterborneHome1Process.343ccedc.jpg";